import Auth from './auth/reducer';
import AppConfig from './appConfig/reducer';
import AuthAs from './authAs/reducer';
import DynamicTabs from './dynamicTabs/reducer';
import Marks from './marks/reducer';
import StaticViews from './staticViews/reducer';
import StudentFinder from './staticViews/studentFinder/reducer';
import { AuthState } from './auth/interfaces';
import { AuthAsState } from './authAs/types';
import { MarksState } from './marks/types';
import { StudentFinderState, SubjectListState } from './staticViews/studentFinder/interfaces';
export interface RootState {
  readonly Auth: AuthState;
  readonly AuthAs: AuthAsState;
  readonly DynamicTabs: DynamicTabsState;
  readonly AppConfig: AppConfig.State;
  readonly Marks: MarksState;
  readonly StaticViews: StaticViewsState;
  readonly StudentFinder: StudentFinderState & SubjectListState;
}

export default {
  Auth,
  AuthAs,
  DynamicTabs,
  AppConfig,
  Marks,
  StaticViews,
  StudentFinder,
};
